export default __webpack_public_path__ + "img/60eeb3776dd00d0d59f78a6dc3fb0acd.svg";